import React from "react";
import { UnreachableError } from "../../utils/error";
import { FooterLinkType } from "../../types/footer";

type Props = {
  data: FooterLinkType;
};

const FooterButton = ({ data }: Props) => {
  if (data.type !== "external") throw new UnreachableError(data.type);

  return (
    <a
      target="_blank"
      rel="noreferrer"
      className="inline-flex items-center gap-1.5 dark:text-soft-blue-grey text-very-dark-grey"
      href={data.link}
    >
      {data.title}
      {data.badge && (
        <span className="inline-flex items-center justify-center px-2 py-1 text-xs leading-none font-semibold rounded-full tracking-wide bg-vivid-orange text-black uppercase">
          {data.badge}
        </span>
      )}
    </a>
  );
};
export default FooterButton;
